import { ProgressBar } from 'react-aria-components';

interface ScoreCircleProps {
  value: number | null;
  /** Stroke color for the progress arc. Defaults to --zf-sc-pass. */
  color?: string;
  size?: number;
}

const R = 20;
const CX = 24;
const CY = 24;
const CIRCUMFERENCE = 2 * Math.PI * R;

export const ScoreCircle = ({
  value,
  color = 'var(--zf-sc-pass)',
  size = 48,
}: ScoreCircleProps) => (
  <ProgressBar
    value={value ?? 0}
    minValue={0}
    maxValue={100}
    aria-label={value !== null ? `Score: ${value}/100` : 'Score: N/A'}
  >
    {({ percentage }) => (
      <svg viewBox="0 0 48 48" width={size} height={size} aria-hidden="true">
        <circle
          cx={CX}
          cy={CY}
          r={R}
          stroke="var(--bui-bg-neutral-2)"
          strokeWidth={4}
          fill="none"
        />
        {value !== null && (
          <circle
            cx={CX}
            cy={CY}
            r={R}
            stroke={color}
            strokeWidth={4}
            fill="none"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={CIRCUMFERENCE * (1 - (percentage ?? 0) / 100)}
            strokeLinecap="round"
            transform={`rotate(-90 ${CX} ${CY})`}
          />
        )}
        <text
          x={CX}
          y={CY}
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={11}
          fontWeight="bold"
          fill="var(--bui-fg-primary)"
        >
          {value ?? '—'}
        </text>
      </svg>
    )}
  </ProgressBar>
);
